import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const editAppBrand = async (payload: Partial<IAppBrand>) => {
	const url = `/homepage/admin/app-branding/${payload.id}/`;
	const response = await cmsClient.put<IAppBrand>(url, payload);

	return response.data;
};

const useEditAppBrand = () => {
	const navigate = useNavigate();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Edited Successfully" />,
			{ hideProgressBar: true }
		);

		navigate("/vendor-sponsorship/app-branding/brands?published=false");
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(editAppBrand, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useEditAppBrand;
